<div class="sync-conv-margin-left">
  <h3 class="crm-sections-title" translate="crm/configuration/sync-conversation-frequence"></h3>
  <a
    *ngIf="crmType === 'salesforce'"
    class="crm-doc-links"
    href="https://developers.alcmeon.com/docs/sf-configuration-alcmeon#frequency"
    target="_blank"
    rel="noopener noreferrer">
    {{ 'crm/configuration/sync-conversation-doc' | translate }}
  </a>
  <ng-container *ngIf="crmType">
    <ng-container [ngSwitch]="crmType">
      <div *ngSwitchCase="'salesforce'">
        <mat-radio-group [formControl]="frequencyControl">
          <mat-radio-button
            *ngFor="let frequency of conversationSyncFrequencies"
            [value]="frequency.id"
            [disabled]="frequency.disabled">
            <strong> {{ frequency.title }} </strong>
            <span> {{ frequency.description }} </span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div *ngSwitchCase="'zendesk'" class="zendesk-synchronization-frequency">
        <ng-container *ngIf="realTimeFrequency">
          <strong> {{ realTimeFrequency.title }} </strong>
          <span> {{ realTimeFrequency.description }} </span>
        </ng-container>
      </div>
      <div *ngSwitchDefault></div>
    </ng-container>
  </ng-container>
</div>
